// extracted by mini-css-extract-plugin
module.exports = {"container":"searchpage_container__3pY-y","results":"searchpage_results__1yrT6","loading":"searchpage_loading__1JLik","message":"searchpage_message__3UnUn"};